import { render } from "./SaleSummaryCard.vue?vue&type=template&id=0c88df28&scoped=true"
import script from "./SaleSummaryCard.vue?vue&type=script&lang=js"
export * from "./SaleSummaryCard.vue?vue&type=script&lang=js"

import "./SaleSummaryCard.vue?vue&type=style&index=0&id=0c88df28&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c88df28"]])

export default __exports__